"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23,15.5l-.76-1.26-2.08,1.25-1-.56,1.32-.79-.76-1.26-2.08,1.25-.51-.27v-3.7l.51-.27,2.08,1.25.76-1.26-1.32-.79,1-.56,2.08,1.25L23,8.51l-1.32-.79,1-.54L22,5.87l-1,.53.09-1.53-1.47-.09-.14,2.42-1,.55.09-1.52-1.47-.09-.14,2.42-.49.26L12.74,6.37V5.76L14.81,4.5,14,3.24,12.74,4V2.86L14.81,1.6,14,.34l-1.31.79V0H11.26V1.15L9.94.35,9.18,1.61l2.08,1.26V4l-1.32-.8L9.18,4.51l2.08,1.26v.6L7.57,8.84l-.49-.26L6.94,6.16l-1.47.09.09,1.52-1-.55L4.38,4.79l-1.47.09L3,6.41,2,5.87,1.3,7.17l1,.54L1,8.51l.76,1.26L3.83,8.52l1,.56-1.32.79.76,1.26L6.39,9.89l.51.27v3.7l-.51.27L4.31,12.88l-.76,1.26,1.32.79-1,.56L1.75,14.24,1,15.5l1.32.8-1,.54L2,18.14l1-.53-.09,1.53,1.47.09.14-2.42,1-.55-.09,1.53,1.47.09.14-2.42.49-.26,3.69,2.47v.59L9.18,19.48l.76,1.26,1.32-.8v1.18L9.18,22.38l.76,1.26,1.32-.8V24h1.47V22.87l1.31.79.77-1.26-2.07-1.26V20l1.31.79.77-1.26-2.07-1.26v-.6l3.7-2.47.49.26.14,2.42,1.47-.09-.09-1.53,1,.55.14,2.42,1.47-.09L21,17.61l1,.53.69-1.3-1-.54Zm-7.39-1.57L12,16.36,8.37,13.94V10.08L12,7.65l3.63,2.42Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;